export default __webpack_public_path__ + "img/tab1and2_nav2-1-b680f4ca.png";